import { isEmpty, roundOfToTwoDigits } from '../../util/util'

export const getFilterList = (filtersData) => {
  const keys = Object?.keys(filtersData)
  const listData: any = []
  keys?.map((key) => {
    if (key === 'min' && !isEmpty(filtersData?.min)) {
      if (isEmpty(filtersData?.max)) {
        listData.push({ key: 'min', value: `Min: ${'\u20B9'} ${filtersData?.min}` })
      } else {
        listData.push({
          key: 'amountRange',
          value: `${'\u20B9'} ${filtersData.min} - ${'\u20B9'} ${filtersData.max}`,
        })
      }
    }
    if (key === 'max' && !isEmpty(filtersData?.max)) {
      if (isEmpty(filtersData?.min)) {
        listData.push({ key: 'max', value: `Max: ${'\u20B9'} ${filtersData?.max}` })
      }
    }
    if (key === 'paymentMode' && filtersData?.paymentMode?.length > 0) {
      filtersData?.paymentMode?.map((item) => {
        listData.push({
          key: 'paymentMode',
          value: item,
        })
      })
    }
    if (key === 'transactionStatus' && filtersData?.transactionStatus?.length > 0) {
      filtersData?.transactionStatus?.map((item) => {
        listData.push({
          key: 'transactionStatus',
          value: item,
        })
      })
    }
    if (
      key === 'selectedDateInfo' &&
      filtersData?.selectedDateInfo?.fromDate &&
      filtersData?.selectedDateInfo?.toDate
    ) {
      const fromDateObj = new Date(filtersData?.selectedDateInfo?.fromDate)
      const toDateObj = new Date(filtersData?.selectedDateInfo?.toDate)
      const fromDate = `${roundOfToTwoDigits(fromDateObj.getDate())}/${roundOfToTwoDigits(
        fromDateObj.getMonth() + 1,
      )}/${fromDateObj.getFullYear()}`
      const toDate = `${roundOfToTwoDigits(toDateObj.getDate())}/${roundOfToTwoDigits(
        toDateObj.getMonth() + 1,
      )}/${toDateObj.getFullYear()}`

      listData.push({ key: 'selectedDateInfo', value: `${fromDate} - ${toDate}` })
    }
  })
  return listData
}
